import Feed from "../components/feed/Feed";
import PinDetail from "../components/pin-detail/PinDetail";
import CreatePin from "../components/create-pin/CreatePin";
import Search from "../components/search/Search";

export const pinsRoute = [
    {
        name: 'feed',
        path: '*',
        Component: Feed,
    },
    {
        name: 'category',
        path: '/category/:categoryId',
        Component: Feed,
    },
    {
        name: 'pinDetail',
        path: '/pin-detail/:pinId',
        Component: PinDetail,
    },
    {
        name: 'createPin',
        path: '/create-pin',
        Component: CreatePin,
    },
    {
        name: 'search',
        path: '/search',
        Component: Search,
    },
]
